<template>
  <div>
    <SDirection v-for="(category, index) in computedCategories"
                :key="index + (category && category.id || '-empty').toString()"
                :value="category"
                :placeholder="$tFilter(!index ? 'category_placeholder' : 'other_category_placeholder')"
                searchable
                url="/api/vacancies-list-v2/directions-list"
                :params="params"
                @input="onCategoryInput($event, index)"
                class="main-filter__select"/>

    <SProfession :value="computedProfession"
                 :placeholder="$tFilter('profession_placeholder')"
                 key="profession"
                 @input="onProfessionInput"
                 url="/api/vacancies-list-v2/categories-list"
                 :params="params"
                 class="main-filter__select"/>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import filterMixin from '@/mixins/filterMixin'
  import SProfession from '@/components/loadingSelects/SCategory'
  import SDirection from '@/components/loadingSelects/SDirection'

  export default {
    mixins: [filterMixin],
    components: {
      SProfession,
      SDirection,
    },
    data() {
      return {
        categoriesInner: [null],
        professionInner: null,
      }
    },
    computed: {
      ...mapGetters('vacancies', [
        'params',
      ]),
      ...mapState('vacancies', [
        'profession',
        'directions',
      ]),
      routeProfessionSlug() {
        let professionsIds = this.$route.params.professionsIds
        if (Array.isArray(professionsIds)) {
          return professionsIds[0] || null
        }

        return professionsIds || null
      },
      computedProfession() {
        const routeProfessionSlug = this.routeProfessionSlug

        if (routeProfessionSlug && routeProfessionSlug === (this.profession && this.profession.slug)) {
          return this.profession
        }

        return routeProfessionSlug ? this.professionInner : null
      },
      categoriesSlugs() {
        let categories = this.$route.query.categories
        if (categories) {
          categories = categories.split('|')
        }
        return categories || []
      },
      computedCategories() {
        const categoriesSlugs = this.categoriesSlugs
        return this.categoriesInner.filter(category => !category || categoriesSlugs.includes(category.slug))
      }
      // computedCategories() {
      //   const directions = this.directions
      //
      //   return this.categoriesSlugs.map((categorySlug) => {
      //     let value = directions.find(d => categorySlug === d.slug)
      //     if (value) {
      //       return value
      //     }
      //
      //     value = this.categoriesInner.find(d => categorySlug === d.slug)
      //     if (value) {
      //       return value
      //     }
      //
      //
      //     return categorySlug
      //   })
      // },
    },
    methods: {
      onCategoryInput(value, index) {
        let categories = JSON.parse(JSON.stringify(this.computedCategories))

        if (value) {
          categories[index] = value

          if (index === categories.length - 1) {
            categories.push(null)
          }
        } else {
          this.$delete(categories, index)
        }

        this.categoriesInner = categories

        categories = categories.filter(c => c)
        categories = categories.map(c => c.slug).join('|')

        this.pushToRouterMixin({
          query: {
            categories: categories || null,
          }
        })
      },
      onProfessionInput(value) {
        this.professionInner = value

        this.pushToRouterMixin({
          params: {
            professionsIds: value ? [value.slug] : []
          }
        })
      }
    },
    created() {
      let categories = JSON.parse(JSON.stringify(this.directions))

      if (categories && categories.length) {
        categories.push(null)
      } else {
        categories = [null]
      }

      this.categoriesInner = categories
    }
  }
</script>

<style lang="less">

</style>